import { connect } from 'react-redux';
import { compose, lifecycle, renderNothing, withHandlers } from 'recompose';

import { addProduct } from '../../order/actions';
import { getActiveBarberId } from '../selectors';
import saleProductsProvider from '../hoc/saleProductsProvider';
import withProducts from '../../../products/products/hoc/withProducts';

const BarcodeScannerListener = compose(
  saleProductsProvider,
  withProducts,
  connect(
    state => ({
      activeBarberId: getActiveBarberId(state),
    }),
    {
      addProduct,
    },
  ),
  withHandlers({
    addScannedProduct: props => (barcode) => {
      const foundProduct = props.products.find(item => item.sku === barcode);
      if (foundProduct) {
        props.addProduct(props.activeBarberId, foundProduct);
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      let barcode = '';
      let lastKeypressTime = -1; // -1 stands for "input not started"
      const keypressThreshold = 500;

      this.listener = (event) => {
        const currentTime = (new Date()).getTime();
        if (lastKeypressTime === -1) {
          lastKeypressTime = currentTime;
        }

        // scanner inputs character by character
        // consider quick keystrokes as barcode scanner input
        if (currentTime - lastKeypressTime <= keypressThreshold) {
          // scanner's input sequence ends with Enter
          if (event.keyCode === 13) {
            this.props.addScannedProduct(barcode);
            barcode = '';
          } else if (event.key !== 'Shift') {
            barcode += event.key;
          }
        } else {
          barcode = '';
        }

        lastKeypressTime = barcode ? currentTime : -1;
      };

      document.addEventListener('keydown', this.listener);
    },
    componentWillUnmount() {
      document.removeEventListener('keydown', this.listener);
    },
  }),
)(renderNothing);

export default BarcodeScannerListener;
